"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="228160" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {[...Array(5)].map((_, i) => <Card key={i} data-index={i} className="animate-pulse shadow-md rounded-none border-border overflow-hidden bg-card">
            <div className="aspect-square bg-muted" />
            <CardContent className="p-6">
              <div className="h-6 bg-muted rounded w-3/4 mb-4" />
              <div className="h-4 bg-muted rounded w-full mb-2" />
              <div className="h-4 bg-muted rounded w-2/3" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="text-destructive p-4 border border-destructive rounded-none">
        Failed to load our signature specials. Please try again later.
      </div>;
  }
  if (products.length === 0) {
    return <div className="text-muted-foreground p-8 text-center border rounded-none border-dashed border-border">
        Our kitchen is preparing new bold flavors. Check back soon.
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="shadow-2xl rounded-none border-border flex flex-col overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(0,0,0,0.8)] bg-card group">
          <Link to={product.link} className="block aspect-square overflow-hidden bg-muted relative">
            {product.featured_image_url ? <>
                <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" />
              </> : <div className="h-full w-full flex items-center justify-center text-muted-foreground bg-muted/50">
                Sultani Grill
              </div>}
          </Link>
          <CardContent className="p-6 flex-1 flex flex-col">
            <Link to={product.link} className="hover:text-primary mb-2 block transition-colors">
              <CardTitle className="font-serif text-2xl font-bold text-foreground line-clamp-1 tracking-wide uppercase">
                {product.title}
              </CardTitle>
            </Link>
            
            {product.short_description && <CardDescription className="text-muted-foreground text-sm mb-4 line-clamp-2 [&>p]:mb-0 font-default" dangerouslySetInnerHTML={{
          __html: product.short_description
        }} />}
            
            <div className="mt-auto pt-4 flex flex-col gap-4">
              <div className="flex items-center justify-between">
                <span className="text-2xl font-bold text-primary font-serif">
                  ${product.price?.toFixed(2)}
                </span>
              </div>
              <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground w-full py-6 font-serif text-lg uppercase tracking-widest hover:bg-primary/90 transition-colors rounded-none" text="Order Now" showQuantity={false} />
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function ProductsOfferings() {
  const wp_query_params = {
    per_page: 5
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}